export default String.raw`
.search-advanced-container {
    padding: 0 5%;

    &__search {
        width: 100%;
        grid-template-columns: 100%;
        row-gap: 24px;
        margin-bottom: 24px;

        &-phrase {
            &-input {
                border-radius: 5px;
            }
        }

        &-categories {
            border-left: 1px solid $inputsBorderColor;
            border-radius: 5px;
        }
    }

    &__find-by {
        margin-bottom: 24px;
    }

    &__price {
        div {
            justify-content: center;
            margin-bottom: 24px - 8px;
        }

        fieldset {
            width: 153px;
        }
    }
    
    &__checkboxes {
        width: 100%;
        grid-template-columns: repeat(2, auto);

        &-two-columns:nth-child(2n + 1) {
            grid-column: initial;
        }

        h4 {
            grid-column: 2 span;
            margin: 8px 0 24px 0;
        }
    }

    &__buttons {
        flex-direction: column;
        align-self: center;
        margin-bottom: 8px;

        button:first-child {
            order: 2;
        }

        button:last-child {
            order: 1;
        }
    }
}
`